import { GOOGLE_SSO_LOADING_LOCAL_STORAGE } from "../components/common/googleSso/constants";

export const STORAGE_API_KEY = 'amber.key';
export const STORAGE_USER_LOGGED_IN = 'amber.user_logged_in';
export const STORAGE_USER_NAME = 'amber.user_name';
export const STORAGE_USER_TYPE = 'amber.user_type';
// Session storage flag: the backend rejected the session because 2FA is required
export const STORAGE_TWO_FACTOR_REQUIRED = 'amber.two_factor_required';
export const STORAGE_LOGIN_METHOD = 'amber.login_method';
export const LOGIN_METHOD_PASSWORD = 'password';
export const LOGIN_METHOD_GOOGLE = 'google';
export const STORAGE_PAYMENT_TERMS_DIALOG_DISMISSED =
  'amber.payment_terms_dialog_dismissed';

// Functions
export function getRoles() {
  const rolesString = localStorage.getItem(STORAGE_USER_TYPE);
  if (!rolesString) {
    return null;
  }

  if (!rolesString.startsWith('[') || !rolesString.endsWith(']')) {
    return [JSON.parse(rolesString)]
  }

  return JSON.parse(rolesString);
}

export function getUserName() {
  return localStorage.getItem(STORAGE_USER_NAME);
}

export function getUserLoggedIn() {
  const loggedInString = localStorage.getItem(STORAGE_USER_LOGGED_IN);
  if (!loggedInString) {
    return false;
  }
  return JSON.parse(loggedInString);
}

/**
 * Remembers how the user logged in, e.g. to know whether Google manages their 2FA
 * @param {string} method LOGIN_METHOD_PASSWORD or LOGIN_METHOD_GOOGLE
 */
export function storeLoginMethod(method) {
  localStorage.setItem(STORAGE_LOGIN_METHOD, method);
}

export function isGoogleLogin() {
  return localStorage.getItem(STORAGE_LOGIN_METHOD) === LOGIN_METHOD_GOOGLE;
}

export function cleanLocalStorage() {
  const username = getUserName();

  localStorage.removeItem(STORAGE_USER_TYPE);
  localStorage.removeItem(STORAGE_USER_LOGGED_IN);
  localStorage.removeItem(STORAGE_USER_NAME);
  localStorage.removeItem(STORAGE_API_KEY);
  localStorage.removeItem(STORAGE_LOGIN_METHOD);
  localStorage.removeItem('lang');
  if (username) {
    localStorage.removeItem(`${STORAGE_PAYMENT_TERMS_DIALOG_DISMISSED}.${username}`);
  }

  // Remove Google SSO login flag from local storage
  localStorage.removeItem(GOOGLE_SSO_LOADING_LOCAL_STORAGE);
}

export function getPaymentTermsDialogDismissed() {
  const username = getUserName();
  if (!username) {
    return false;
  }
  return localStorage.getItem(`${STORAGE_PAYMENT_TERMS_DIALOG_DISMISSED}.${username}`) === 'true';
}

export function setPaymentTermsDialogDismissed() {
  const username = getUserName();
  if (!username) {
    return;
  }
  localStorage.setItem(`${STORAGE_PAYMENT_TERMS_DIALOG_DISMISSED}.${username}`, 'true');
}

export function logout(history) {
  cleanLocalStorage();

  if (history) {
    history.push('/');
  } else {
    document.location.replace('/');
  }
}

export function getLoginDetails() {
  return {
    role: getRoles(),
    userName: getUserName(),
    isLoggedIn: getUserLoggedIn(),
  };
}
